export const urlSection = 'url';
export const assetIdSection = 'assetId';
export const enterpriseSection = 'enterpriseGuid';
export const participantsSection = 'numParticipants';
export const apiUserSection = 'apiUserId';



// WEBPACK FOOTER //
// src/portal-setup/portal-setup-constants.js